import { useTranslation } from 'react-i18next'

import Button from '../../../Button'
import { MoreActionsButton } from '../../../MoreActionsButton'

import {
  QA_NAME_PREVIEW_ACTION,
  QA_NAME_TEST_VARIABLES_ACTION,
} from './EmailCreationFormHelpersActions.constants'
import { getDisabledTooltipKey } from './EmailCreationFormHelpersActions.utils'

import * as styles from './EmailCreationFormHelpersActions.module.css'

function EmailCreationFormHelpersActions({
  disabled,
  disablePreview,
  disableVariables,
  emptyAccountField,
  emptyRecipients,
  isTesting,
  mass,
  onPreview,
  onTestVariables,
}) {
  const { t } = useTranslation()

  const testVariablesTooltip = disableVariables
    ? t(
        getDisabledTooltipKey({
          emptyAccountField,
          emptyRecipients,
          mass,
        })
      )
    : null

  const previewTooltip = disablePreview
    ? t(
        emptyRecipients
          ? 'Emails.EmptyToFieldTooltipPreviewBtnKey'
          : 'Emails.EmptyFromFieldTooltipPreviewBtnKey'
      )
    : null

  const actions = [
    {
      Component: Button.Flat,
      disabled: disableVariables,
      height: 40,
      isGrey: true,
      isLoading: isTesting,
      key: 'test-variables',
      qaName: QA_NAME_TEST_VARIABLES_ACTION,
      text: t('Emails.TestVariablesActionKey'),
      tooltip: testVariablesTooltip,
      onClick: onTestVariables,
    },
    {
      Component: Button.Flat,
      disabled: disablePreview,
      height: 40,
      isGrey: true,
      key: 'preview',
      qaName: QA_NAME_PREVIEW_ACTION,
      text: t('Emails.PreviewActionKey'),
      tooltip: previewTooltip,
      onClick: onPreview,
    },
  ]

  return (
    <MoreActionsButton
      actions={actions}
      actionsClassName={styles.actions}
      disabled={disabled}
      text={t('Common.More')}
    />
  )
}

export default EmailCreationFormHelpersActions
